import React from 'react'
import ArticleField from '../ArticleField';
import { TextField } from '@material-ui/core';

interface MetaTitleProps {
    value: string,
    onChange: (value: string) => void
}

const MetaTitle = (props: MetaTitleProps) => (
    <ArticleField>
        <TextField
            inputProps={{ maxLength: 256 }}
            fullWidth={true} label="Meta Title"
            value={props.value}
            onChange={(e) => {
                props.onChange(e.target.value);
            }} />
        {props.value.length}/256
    </ArticleField>
);

export default MetaTitle;